import React from "react";

const PrivacyPolicy: React.FC = () => {
  return (
    <main style={{ padding: "24px", maxWidth: "800px", margin: "0 auto" }}>
      <h1>Privacy Policy</h1>
      <p>
        At <strong>KunalDoorAndMore</strong>, we respect your privacy and are committed
        to protecting your personal data.
      </p>

      <h2>Information We Collect</h2>
      <p>
        Our WhatsApp integration may collect basic contact information (such as
        phone numbers) for communication purposes. We do not sell, rent, or share
        this data with third parties.
      </p>

      <h2>How We Use Your Data</h2>
      <p>
        Your data is only used to provide and improve our services, such as
        customer support and order updates.
      </p>

      <h2>Data Deletion</h2>
      <p>
        If you would like your data deleted, please visit our{" "}
        <a href="/user/delete-data">Data Deletion Page</a> or email us at{" "}
        <a href="mailto:Kunaldoors@gmail.com">Kunaldoors@gmail.com</a>.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, you can contact us
        at: <br />
        Email:{" "}
        <a href="mailto:Kunaldoors@gmail.com">Kunaldoors@gmail.com</a>
      </p>
    </main>
  );
};

export default PrivacyPolicy;